module.exports = __webpack_public_path__ + "img/selfServiceImg3.288d2ce.svg";